import { render, staticRenderFns } from "./ProjectDetailsModal.vue?vue&type=template&id=f7f52718&scoped=true&"
import script from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsModal.vue?vue&type=style&index=0&id=f7f52718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f52718",
  null
  
)

export default component.exports